import { onViewLoad } from "~/jose_modern/on_view_load.js";
import { initEditTitle } from "../shared/edit_title.js";
import { initCsvDownload } from "../shared/csv_download.js";

const scan = (container) => initEditTitle(container);

onViewLoad("purchase_orders#show", () => {
  scan(document);
  initCsvDownload(document);
  document.addEventListener("partial:replace", (ev) => scan(ev.container));
});
